module.exports = __webpack_public_path__ + "media/images/pages/who_we_are/team-6-c7d7f2e02c4d5178401f63a8e1eb779e.png";